import { SnackbarProvider } from 'notistack';
import React from 'react';
import useStyles from './SnackProviderStyles';
export default function SnackProvider({
  children
}) {
  const {
    variantError,
    variantInfo
  } = useStyles();
  return /*#__PURE__*/React.createElement(SnackbarProvider, {
    maxSnack: 3,
    classes: {
      variantError,
      variantInfo
    },
    preventDuplicate: true,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    }
  }, children);
}